import React, { useEffect, useRef, useState } from 'react'

import './InputText.scss'

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string
  onChange?: (value: string) => void
  onStartEditing?: () => void
  placeholder?: string
  className?: string
  delay?: number
  disabled?: boolean
  error?: any
  asButton?: boolean
  onClick?: () => void
}

const InputText = (props: Props) => {

  const {
    value,
    onChange,
    onStartEditing,
    placeholder,
    className = '',
    delay = 1000,
    error,
    asButton,
    onClick,
    disabled,
    ...rest
  } = props

  const lastSent = useRef<string>(value)

  const [internalValue, setInternalValue] = useState(value)

  useEffect(() => {

    let text = value

    if (asButton) {
      text = value || placeholder || ''
    }

    setInternalValue(text)
  }, [value])

  useEffect(() => {
    const handler = setTimeout(() => {
      if (internalValue !== lastSent.current) {
        if (onChange) {

          onChange(internalValue)
        }
        lastSent.current = internalValue
      }
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [internalValue, delay])

  if (asButton) {
    return (
      <button
        type="button"
        className={`input-text as-button ${className} ${error ? 'error' : ''}`}
        onClick={() => {
          if (disabled) return

          onClick?.()
        }}
      >
        {internalValue}
      </button>
    )
  }

  return (
    <input
      type="text"
      value={internalValue}
      onChange={(e) => {

        if (onStartEditing) onStartEditing()
        setInternalValue(e.target.value)
      }}
      placeholder={placeholder}
      className={`input-text ${className} ${error ? 'error' : ''}`}
      {...rest}
    />
  )
}

export default InputText